export default __webpack_public_path__ + "static/media/profile-img.55e7711b.png";